import { render, staticRenderFns } from "./mopiVehicle.vue?vue&type=template&id=4c061936&scoped=true&"
import script from "./mopiVehicle.vue?vue&type=script&lang=js&"
export * from "./mopiVehicle.vue?vue&type=script&lang=js&"
import style0 from "./mopiVehicle.vue?vue&type=style&index=0&id=4c061936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c061936",
  null
  
)

export default component.exports